var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Edit the User")]),_c('p',[_vm._v("Locale: "+_vm._s(_vm.$route.query.locale))]),_c('p',[_vm._v("Analytices: "+_vm._s(_vm.$route.query.q))])])}
var staticRenderFns = []

export { render, staticRenderFns }